import React, {useEffect, useState} from "react"
import { Box, Grid, Paper } from "@mui/material"
import { ListClinicCases, NavTab } from "../components"
import { useLocation } from "react-router-dom"
import { disclaimer } from "../utils/constants"

export default function List() {
    const location = useLocation()
    const [currentIndexTab, setCurrentIndexTab] = useState(location?.state?.indexTab || 0)
    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState()

    useEffect(() => {
        // TODO - CATEGORIAS DEVEM VIR DO BE
        const categories= [
            {
                name: "todos",  
            },
            {
                name: "categoria 1",
                categoria: 1    
            },
            {
                name: "categoria 2",
                categoria: 2    
            },
            {
                name: "categoria 3",
                categoria: 3    
            },
            {
                name: "categoria 4",
                categoria: 4    
            },
            {
                name: "categoria 5",
                categoria: 5
            },
            {
                name: "categoria 6",
                categoria: 6    
            },
            {
                name: "avaliados",
                onlyEvaluated: true  
            }
        ]
 
        setCategories(categories)
        setCategory(categories[currentIndexTab])
    }, [])

    const handleChange = (_, newIndexTab) => {
        setCurrentIndexTab(newIndexTab)
        setCategory(categories[newIndexTab])
    }
    
    return (<>
            <Box sx={{mb:"150px"}}>
                <NavTab {...{handleChange, categories, currentIndexTab, setCurrentIndexTab}} />
                <Grid  sx={{ mt:2,display:"flex"}}>
                    <ListClinicCases {...{currentIndexTab, categories, category}}/> 
                </Grid>
            </Box>
            <Box className="mainBox">
                <Paper
                    className="disclaimer"
                    elevation={0}
                    dangerouslySetInnerHTML={{ __html: disclaimer }}
                />
            </Box>
            </>
    )
}
